import { LeadScore } from "../../../types"
import LeadScoreCard from "./lead-score-card"

interface Props {
  scores: LeadScore[]
}

const LeadScoreList = ({ scores }: Props) => {
  return (
    <div className="space-y-3">
      {scores.map((score, index) => (
        <LeadScoreCard key={score.id} score={score} index={index} />
      ))}
    </div>
  )
}

export default LeadScoreList
